var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "button",
    {
      staticClass: "icon-button",
      class: { "icon-button--disabled": _vm.disabled },
      style: `--width: ${_vm.svgSize.w}px; --height: ${_vm.svgSize.h}px;`,
    },
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }